module.exports = global["SegmentIO"] = require("-!/var/www/html/node_modules/rp-analytics/lib/index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/index.js
// module id = 51
// module chunks = 1